import { LocalStorage } from '@/lib/utils/local-storage'
import { deleteCookie, getCookie, setCookie } from 'cookies-next'
import { generateUUID } from '../utils/crypto'

export class DeviceTokenHelper {
  private static readonly COOKIE_NAME = 'device_token'
  private static readonly LOCAL_STORAGE_KEY = 'device_token'
  private static readonly EXPIRY_DAYS = 365

  /**
   * Gets the device token from localStorage or generates a new one
   * @returns Device token string
   */
  static get(): string {
    // 1. Thử lấy từ cookie trước (để tương thích với bản cũ)
    const cookieToken = getCookie(this.COOKIE_NAME)
    if (cookieToken) {
      // Nếu có token trong cookie, lưu vào localStorage để đồng bộ
      this.setToLocalStorage(cookieToken as string)
      return cookieToken as string
    }

    // 2. Thử lấy từ localStorage
    const localToken = this.getFromLocalStorage()
    if (localToken) {
      // Nếu có token trong localStorage, lưu vào cookie để đồng bộ
      this.setToCookie(localToken)
      return localToken
    }

    // 3. Nếu không có ở cả 2 nơi, tạo mới
    const newToken = generateUUID()
    this.set(newToken)
    return newToken
  }

  static set(token: string): void {
    this.setToCookie(token)
    this.setToLocalStorage(token)
  }

  private static setToCookie(token: string): void {
    // Set cookie với domain dựa trên NEXT_PUBLIC_ENV
    setCookie(this.COOKIE_NAME, token, {
      maxAge: this.EXPIRY_DAYS * 24 * 60 * 60,
    })
  }

  private static setToLocalStorage(token: string): void {
    LocalStorage.setWithExpiry(
      this.LOCAL_STORAGE_KEY,
      token,
      this.EXPIRY_DAYS * 24 * 60
    )
  }

  private static getFromLocalStorage(): string | null {
    return LocalStorage.get<string>(this.LOCAL_STORAGE_KEY)
  }

  static remove(): void {
    LocalStorage.remove(this.LOCAL_STORAGE_KEY)
    deleteCookie(this.COOKIE_NAME)
  }
}
